import store from "@/store";
import { isMobileDevice } from "@/utils/matchMedia.js";
import oneMessage from "@/utils/oneMessage.js";
let inputElement = null;
let currDataObj = null; //输入框数据对应的对象
let bGoOn = true; //是否继续执行
let otherData = {}; //用于存放传进来的任何参数
let inputLabel = null; // 新增：用于显示提示语的label元素
let isInputElementVisible = false; // 新增：用于跟踪输入框显示状态
let functionType = "";
//获取输入框
export const getInputOtherElement = () => {
  if (window.drawArcByPointsPreviewAngle) {
    window.drawArcByPointsPreviewAngle = null;
  }
  if (window.drawArcByCenterRadiusPreviewAngle) {
    window.drawArcByCenterRadiusPreviewAngle = null;
  }
  functionType = "";
  return inputElement;
};

//获取输入框当前对应的对象
export const getCurrDataObjOther = () => {
  return currDataObj;
};

//获取其他传进来的参数
export const getOtherDataOther = () => {
  return otherData;
};
const isMobile = isMobileDevice();
//创建输入框
export const createInputOtherElement = (obj = null) => {
  currDataObj = obj;
  if (inputElement) return inputElement;

  // 创建包装容器
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.zIndex = "999";

  // 创建输入框
  inputElement = document.createElement("input");
  inputElement.type = "number";
  // 添加数字键盘标识符，使用自定义键盘
  inputElement.setAttribute("data-rl-keypad", "true");

  // 创建提示语label
  inputLabel = document.createElement("div");
  inputLabel.style.position = "absolute";
  inputLabel.style.right = "100%";
  inputLabel.style.top = "50%";
  inputLabel.style.transform = "translateY(-50%)";
  inputLabel.style.marginRight = "8px";
  inputLabel.style.color = "#555";
  inputLabel.style.fontSize = "12px";
  inputLabel.style.whiteSpace = "nowrap";
  inputLabel.style.display = "none"; // 默认隐藏
  inputLabel.textContent = "请输入数值";

  // 设置基本样式
  inputElement.style.width = "80px";
  inputElement.style.height = "20px";
  inputElement.style.border = "2px solid rgb(117, 193, 196)";
  inputElement.style.background = "linear-gradient(135deg, #f0f0f0, #fafafa)"; // 渐变背景
  inputElement.style.textAlign = "center";
  inputElement.style.display = "block";
  inputElement.style.zIndex = 999;
  inputElement.style.top = "50px"; // 设置初始位置
  inputElement.style.left = "50px"; // 设置初始位置
  inputElement.autocomplete = "off"; //关闭自动完成
  isMobile && (inputElement.style.userSelect = "none"); //这里禁止全选

  // 创建样式表以隐藏数字输入框的上下箭头
  const style = document.createElement("style");
  style.innerHTML = `
/* 隐藏 Chrome, Safari, Edge 中的箭头 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 隐藏 Firefox 中的箭头 */
input[type="number"] {
  -moz-appearance: textfield;
}
`;
  document.head.appendChild(style);
  //////////////////////

  // 添加圆角和阴影效果
  inputElement.style.borderRadius = "10px"; // 更大的圆角
  inputElement.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.15)"; // 更显著的阴影效果

  // 修改字体样式
  inputElement.style.fontSize = "14px"; // 更大的字体大小
  inputElement.style.color = "#555"; // 字体颜色

  // 修改 focus 状态时的样式
  inputElement.addEventListener("focus", function () {
    inputElement.style.borderColor = "rgb(99, 163, 166)"; // 焦点时更深的蓝色边框
    inputElement.style.boxShadow = "0px 6px 20px rgba(0, 123, 255, 0.4)"; // 增强的阴影效果
    inputElement.style.background =
      "linear-gradient(135deg, rgb(225, 245, 246), #ffffff)"; // 焦点时的渐变背景
    if (!isMobile) {
      inputElement.select(); // 选中全部内容
    } else {
      inputElement.value = "";
      window.document.body.classList.add("mobile-main");
    }
  });

  // 当失去焦点时还原样式
  inputElement.addEventListener("blur", function () {
    inputElement.style.borderColor = "rgb(117, 193, 196)"; // 恢复默认蓝色边框
    inputElement.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.15)"; // 恢复阴影效果
    inputElement.style.background = "linear-gradient(135deg, #f0f0f0, #fafafa)"; // 恢复背景
    if (isMobile) {
      window.document.body.classList.remove("mobile-main");
    }
  });

  // 监听输入事件，确保输入内容为数字
  inputElement.addEventListener("input", function () {
    let val = inputElement.value;
    // 只允许数字、负号和小数点
    val = val.replace(/[^0-9.-]/g, "");
    // 只允许首位负号
    if (val.startsWith("-")) {
      val = "-" + val.slice(1).replace(/-/g, "");
    } else {
      val = val.replace(/-/g, "");
    }
    // 只允许一个小数点
    let firstDot = val.indexOf(".");
    if (firstDot !== -1) {
      val =
        val.slice(0, firstDot + 1) + val.slice(firstDot + 1).replace(/\./g, "");
    }
    inputElement.value = val;
  });

  // 监听键盘事件，检测到回车键时失去焦点
  inputElement.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      setInputBlurOther(); // 失去焦点
    }
  });

  // 监听更改事件，输入框的值发生变化并失去焦点
  // inputElement.addEventListener("change", function () {
  //   // 当值变化并失去焦点时记录值
  //   setInputBlur();
  // });

  // 将输入框和label添加到容器中
  container.appendChild(inputLabel);
  container.appendChild(inputElement);
  document.body.appendChild(container);

  return inputElement;
};

//修改输入框的位置及文本内容
export const setInputElementPositionOther = (text, x, y) => {
  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );
  text = isNaN(text) ? 0 : text;
  inputElement.value = Number(text);

  // 更新容器位置
  const container = inputElement.parentElement;

  // 获取输入框的尺寸
  const containerWidth = container.offsetWidth || 80;
  const containerHeight = container.offsetHeight || 20;

  // 获取视窗尺寸
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // 计算输入框应该放置的位置，确保不超出屏幕
  let leftPos = pxPoint.x;
  let topPos = pxPoint.y + 10;

  // 处理左右边界
  if (leftPos + containerWidth > viewportWidth) {
    leftPos = viewportWidth - containerWidth - 10; // 留10px边距
  }
  if (leftPos < 10) {
    leftPos = 10; // 至少距离屏幕左边10px
  }

  // 处理上下边界
  if (topPos + containerHeight > viewportHeight) {
    topPos = viewportHeight - containerHeight - 10; // 留10px边距
  }
  if (topPos < 10) {
    topPos = 10; // 至少距离屏幕顶部10px
  }

  // 应用计算后的位置
  container.style.left = leftPos + "px";
  container.style.top = topPos + "px";
};

//设置输入框的显示状态及提示语
export const setContainerShowOther = (
  inputElementShow,
  inputLabelShow = false,
  inputLabelText = ""
) => {
  // 检查状态是否变化
  if (isInputElementVisible !== inputElementShow) {
    isInputElementVisible = inputElementShow;
    // console.log(
    //   `输入框显示状态变更: ${isInputElementVisible ? "显示" : "隐藏"}`
    // );
    // 如果输入框隐藏，则清除多余线
    if (!isInputElementVisible) {
      // 清除多余线
      clearExtraLineOther();
    }
  }

  if (!inputElementShow) {
    if (inputElement) {
      inputElement.style.display = "none";
    }
    if (inputLabel) {
      inputLabel.style.display = "none";
      inputLabel.textContent = "";
    }
  } else {
    if (inputElement) {
      inputElement.style.display = "block";
    }
    if (inputLabel) {
      inputLabel.style.display = inputLabelShow ? "block" : "none";
      inputLabel.textContent = inputLabelText;
    }
  }
};

//设置当前的对象
export const setCurrDataObjOther = (obj) => {
  currDataObj = obj;
  inputElement.readOnly = false;
};

//设置其他传进来的参数
export const setOtherDataOther = (obj) => {
  otherData = obj;
};

//清除其他传进来的参数
export const eraseOtherDataOther = () => {
  if (otherData) {
    if (otherData.mDimensionObj1) {
      otherData.mDimensionObj1.erase();
      otherData.mDimensionObj1 = null;
    }
    if (otherData.mDimensionObj2) {
      otherData.mDimensionObj2.erase();
      otherData.mDimensionObj2 = null;
    }
    if (otherData.polylineObj) {
      otherData.polylineObj.erase();
      otherData.polylineObj = null;
    }
  }
  // otherData = {};
};

//获取输入框数值
export const getInptNumOther = () => {
  return parseInt(inputElement.value);
};

//清除多余线方法
export const clearExtraLineOther = (eraseOther = true) => {
  // 清除标注
  const mDimensionId = store.state.globalData.mDimensionId;

  if (mDimensionId) {
    mDimensionId.erase();
    store.commit("globalData/setmDimensionId", null);
  }

  // 检查并清除
  const dimensionObj = store.state.globalData.dimensionObj;
  if (dimensionObj) {
    dimensionObj.erase();
    store.commit("globalData/setDimensionObj", null);
  }

  // 清除当前轴线
  const currentMcDbId = store.state.globalData.currentMcDbId;
  if (currentMcDbId) {
    currentMcDbId.erase();
    store.commit("globalData/setCurrentMcDbId", null);
  }

  // 清除当前圆弧
  const currentArcMcDbId = store.state.globalData.currentArcMcDbId;
  if (currentArcMcDbId) {
    currentArcMcDbId.erase();
    store.commit("globalData/setCurrentArcMcDbId", null);
  }
  // 清除其他数据--输入框时的多余线
  if (eraseOther) eraseOtherDataOther();
  // 清除圆弧角度
  // if (window.drawArcByPointsPreviewAngle) {
  //   window.drawArcByPointsPreviewAngle = null;
  // }
  // functionType = "";
};

//设置输入框失焦
export const setInputBlurOther = async () => {
  // 清除多余线
  clearExtraLineOther(false);
  inputElement.type = "number";
  inputElement.readOnly = false;
  // 是否数据无效
  let isInvalid = false;
  let inputValue = parseInt(inputElement.value);
  if (functionType == "drawArcByPointsPreview") {
    if (inputValue > 360) {
      oneMessage.warning("角度不能大于360度");
      return;
    }
    window.drawArcByPointsPreviewAngle = inputValue;
    setContainerShowOther(false);
    if (!store.state.app.isPcMode) {
      if (window.drawArcByPointsPreviewLength) {
        oneMessage.success("请点击屏幕确定圆弧拱高");
      } else {
        oneMessage.success("请确认圆弧直径或者点击屏幕并拖动确定圆弧拱高");
      }
    } else {
      if (window.drawArcByPointsPreviewLength) {
        oneMessage.success("请点击屏幕并拖动确定圆弧拱高");
      } else {
        oneMessage.success("请确认圆弧直径或者点击屏幕并拖动确定圆弧拱高");
      }
    }
    return;
  }
  if (functionType == "drawArcByCenterRadiusPreview") {
    if (inputValue > 360) {
      oneMessage.warning("角度不能大于360度");
      return;
    }
    window.drawArcByCenterRadiusPreviewAngle = inputValue;
    setContainerShowOther(false);
    if (!store.state.app.isPcMode) {
      if (window.drawArcByCenterRadiusPreviewLength) {
        oneMessage.success("请点击屏幕确定圆弧夹角");
      } else {
        oneMessage.success("请确认圆弧半径或者点击屏幕并拖动确定圆弧夹角");
      }
    } else {
      if (window.drawArcByCenterRadiusPreviewLength) {
        oneMessage.success("请点击屏幕并拖动确定圆弧夹角");
      } else {
        oneMessage.success("请确认圆弧半径或者点击屏幕并拖动确定圆弧夹角");
      }
    }
    return;
  }
};
let touchStartHandlerRef = null;
let canvasListener = null;
export const removeInputTouchListener = () => {
  if (touchStartHandlerRef) {
    canvasListener.removeEventListener("touchstart", touchStartHandlerRef);
    touchStartHandlerRef = null;
  }
  canvasListener = null;
};

//设置提示语
export const setInputPlaceholderOther = (text) => {
  if (inputLabel) {
    inputLabel.textContent = text;
    inputLabel.style.display = "block"; // 显示label

    // 如果设置了提示语但输入框是隐藏的，可能需要检查一下
    if (!isInputElementVisible && inputElement) {
      console.log("警告: 设置了提示语但输入框当前是隐藏状态");
    }
  }
};

export const setFunctionType = (type) => {
  functionType = type;
};

export const getFunctionType = () => {
  return functionType;
};
